import { useApplicationCallbacks } from '../../../application-callbacks';

export const useInteractiveShop = () => {
  const { setCurrentOnboardingStep, addCurrentStepToCompleted } = useApplicationCallbacks();

  const update = (type) => {
    setCurrentOnboardingStep(type);
    addCurrentStepToCompleted();
  };

  return {
    updateOnboarding: update,
  };
};
